export const refundLocaleEs = {
  'refund.clcCodigo': 'Código de la compra',
  'refund.clcCodigo.placeholder': '1234',
  'refund.cliNombre': 'Nombre del cliente',
  'refund.cliNombre.placeholder': 'Juan Pérez',
  'refund.cliEmail': 'Correo electrónico',
  'refund.cliEmail.placeholder': 'correo@ejemplo.com',
  'refund.docIdentidad': 'Documento de identidad',
  'refund.docIdentidad.placeholder': '1234',
  'refund.cliTelefono': 'Teléfono',
  'refund.cliTelefono.placeholder': '(555) 5555-5555',
  'refund.formaPago': 'Forma de pago',
  'refund.monto': 'Monto',
  'refund.motivo': 'Motivo de la devolución',
  'refund.motivo.placeholder': 'Describe brevemente la razón del reembolso...',
  'refund.cash': 'Efectivo',
  'refund.card': 'Tarjeta',
  'refund.cardHolderName': 'Nombre en la tarjeta',
  'refund.cardHolderName.placeholder': 'Juan Pérez',
  'refund.cardLastDigits': 'Últimos 4 dígitos de la tarjeta',
  'refund.cardLastDigits.placeholder': '1234',

  'refund.required.codClc': 'Por favor ingresa el código de la compra',
  'refund.required.nombreCompleto': 'Por favor ingresa tu nombre completo',
  'refund.required.correo': 'Por favor ingresa tu correo electrónico',
  'refund.invalid.correo': 'Por favor ingresa un correo electrónico válido',
  'refund.required.numeroIdentificacion':
    'Por favor ingresa tu número de identificación',
  'refund.required.tefono': 'Por favor ingresa tu número de teléfono',
  'refund.required.formaPago': 'Por favor selecciona una forma de pago',
  'refund.required.descripcion': 'Por favor describe la razón del reembolso',
  'refund.required.cardHolderName': 'Por favor ingresa el nombre en la tarjeta',
  'refund.required.ultimosDigitosTarjeta':
    'Por favor ingresa los últimos 4 dígitos de la tarjeta',
  'refund.required.montoPagado': 'Por favor ingresa el monto pagado',

  'refund.submit': 'Enviar solicitud',

  'refund.loading': 'Enviando solicitud...',
  'refund.success': 'Solicitud enviada con éxito',
  'refund.error': 'Ocurrió un error al enviar la solicitud',
} as const;

export const refundLocaleEn = {
  'refund.clcCodigo': 'Purchase code',
  'refund.clcCodigo.placeholder': '1234',
  'refund.cliNombre': 'Client name',
  'refund.cliNombre.placeholder': 'Jhon Doe',
  'refund.cliEmail': 'Email',
  'refund.cliEmail.placeholder': 'email@example.com',
  'refund.docIdentidad': 'Identity document',
  'refund.docIdentidad.placeholder': '1234',
  'refund.cliTelefono': 'Phone',
  'refund.cliTelefono.placeholder': '(555) 555-5555',
  'refund.formaPago': 'Payment method',
  'refund.monto': 'Amount',
  'refund.motivo': 'Refund reason',
  'refund.motivo.placeholder': 'Briefly describe the reason for the refund...',
  'refund.cash': 'Cash',
  'refund.card': 'Card',
  'refund.cardHolderName': 'Cardholder name',
  'refund.cardHolderName.placeholder': 'Jhon Doe',
  'refund.cardLastDigits': 'Last 4 digits of the card',
  'refund.cardLastDigits.placeholder': '1234',

  'refund.required.codClc': 'Please enter the purchase code',
  'refund.required.nombreCompleto': 'Please enter your full name',
  'refund.required.correo': 'Please enter your email',
  'refund.invalid.correo': 'Please enter a valid email',
  'refund.required.numeroIdentificacion':
    'Please enter your identification number',
  'refund.required.tefono': 'Please enter your phone number',
  'refund.required.formaPago': 'Please select a payment method',
  'refund.required.descripcion': 'Please describe the reason for the refund',
  'refund.required.cardHolderName': 'Please enter the name on the card',
  'refund.required.ultimosDigitosTarjeta':
    'Please enter the last 4 digits of the card',
  'refund.required.montoPagado': 'Please enter the amount paid',

  'refund.submit': 'Submit request',

  'refund.loading': 'Sending request...',
  'refund.success': 'Request sent successfully',
  'refund.error': 'An error occurred while sending the request',
} as const;
